// Analyser response from core: { count, coords: [lon1,lat1,lon2,lat2, …], columns: { key: [...] } }
// — one entry per RNW leg, all arrays indexed by leg position.

const RENDER_KEYS = [
  "id",
  "usage",
  "ww_nav_cat",
  "ww_is_free_vessel_vertical_clearance",
  "ww_legUsable",
];

function getMinLengthMetersForZoomAndUsage(z, usage) {
  if (usage === 3 || usage === 4) {
    if (z < 4) return 10000;
    if (z < 5) return 5000;
    if (z < 6) return 2000;
    return 0;
  }
  if (z < 4) return 100000;
  if (z < 5) return 20000;
  if (z < 6) return 10000;
  return 0;
}

export function computeLegLengths(legs) {
  const { count, coords } = legs;
  const lengths = new Float32Array(count);
  for (let i = 0; i < count; i += 1) {
    const dLon = coords[4 * i + 2] - coords[4 * i];
    const dLat = coords[4 * i + 3] - coords[4 * i + 1];
    lengths[i] = Math.sqrt(dLon * dLon + dLat * dLat) * 111000;
  }
  return lengths;
}

export function computeClosedViaAreaFlags(legs, legToViaAreaLinks, closedViaAreaIds) {
  const flags = new Uint8Array(legs.count);
  if (!closedViaAreaIds?.length || !legToViaAreaLinks?.length) return flags;

  const closed = new Set(closedViaAreaIds);
  const closedLegIds = new Set(
    legToViaAreaLinks
      .filter((link) => closed.has(link.properties.via_area_id))
      .map((link) => link.properties.leg_id),
  );
  const ids = legs.columns.id;
  for (let i = 0; i < legs.count; i += 1) {
    if (closedLegIds.has(ids[i])) flags[i] = 1;
  }
  return flags;
}

function legFeature(legs, i, closedFlags) {
  const { coords, columns } = legs;
  const properties = { legIndex: i, ww_is_closed_viaarea: closedFlags[i] === 1 };
  for (const key of RENDER_KEYS) properties[key] = columns[key]?.[i];
  return {
    type: "Feature",
    geometry: {
      type: "LineString",
      coordinates: [
        [coords[4 * i], coords[4 * i + 1]],
        [coords[4 * i + 2], coords[4 * i + 3]],
      ],
    },
    properties,
  };
}

export function selectVisibleLegFeatures(legs, lengths, closedFlags, bounds, zoom) {
  const { south, west, north, east } = bounds;
  const { count, coords } = legs;
  const usage = legs.columns.usage;
  const visible = [];
  for (let i = 0; i < count; i += 1) {
    const lon1 = coords[4 * i];
    const lat1 = coords[4 * i + 1];
    const lon2 = coords[4 * i + 2];
    const lat2 = coords[4 * i + 3];
    if (Math.max(lon1, lon2) < west || Math.min(lon1, lon2) > east) continue;
    if (Math.max(lat1, lat2) < south || Math.min(lat1, lat2) > north) continue;
    if (lengths[i] < getMinLengthMetersForZoomAndUsage(zoom, usage?.[i])) continue;
    visible.push(legFeature(legs, i, closedFlags));
  }
  return visible;
}

export function legPopupProperties(legs, i, closedFlags) {
  const properties = {};
  for (const [key, values] of Object.entries(legs.columns)) {
    properties[key] = values[i];
  }
  properties.ww_is_closed_viaarea = closedFlags[i] === 1;
  return properties;
}
